import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-white border-t border-gray-200">
      <div className="container mx-auto px-4 py-6">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-3 text-sm text-gray-600">
          <div className="flex items-center gap-2">
            <span>&copy; {new Date().getFullYear()} The Web Dev Interview</span>
          </div>
          <div className="flex items-center gap-4">
            <Link to="/" className="hover:text-orange-600 transition-colors">Home</Link>
            <Link to="/mock-interview" className="hover:text-orange-600 transition-colors">Mock Interview</Link>
            <Link to="/about" className="hover:text-orange-600 transition-colors">About</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
